import {Injectable} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";
import {filter, map, mergeMap} from "rxjs/operators";
import {Title} from "@angular/platform-browser";
import {NgDynamicBreadcrumbService} from "../../components/breadcrumb/ng-dynamic-breadcrumb.service";
import { AppConfigurationService } from '../../../core/appConfiguration/app-configuration.service';

@Injectable({
  providedIn: 'root'
})
export class TitleMediatorService {

  constructor(
    private title: Title,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private breadcrumbService: NgDynamicBreadcrumbService,
    public _appConfig: AppConfigurationService
  ) {}

  /**
   * Initialize the service to set the title based on route data.
   */
  public init() {
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => this.getChild(this.activatedRoute)),
        mergeMap(route => route.data)
      )
      .subscribe(data => {
        const title: string = this.getTitle(data?.['title']);
        this.setTitle(title);
        this.breadcrumbService.notifyRouterFun({
          data: data,
          params: this.activatedRoute.snapshot.params,
        });
      });
  }

  /**
   * Get the complete title for the current route.
   *
   * @param routeTitle - The title from the route data.
   * @returns The complete title.
   */
  public getTitle(routeTitle?: string): string {
    // Customize title manipulation logic here
    return routeTitle ? `${routeTitle} | ${(this._appConfig.appConfig.appName || '')}` : (this._appConfig.appConfig.appName || '');
  }

  /**
   * Set the document title.
   *
   * @param title - The title to set.
   */
  public setTitle(title: string): void {
    this.title.setTitle(title);
  }

  /**
   * Recursively get the child route.
   *
   * @param activatedRoute - The current activated route.
   * @returns The deepest child route.
   */
  private getChild(activatedRoute: ActivatedRoute): ActivatedRoute {
    if (activatedRoute.firstChild) {
      return this.getChild(activatedRoute.firstChild);
    } else {
      return activatedRoute;
    }
  }
}
